import Swiper from 'swiper';

function sliderStoriesCarousel() {
  new Swiper('.course-hero__carousel', {
    grabCursor: true,
    spaceBetween: 8,
    slidesPerView: 'auto',
  });
}
sliderStoriesCarousel();